import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { ConfirmDialogComponent } from 'ngx-mat-esign360/lib/dialog/components/confirm-dialog/confirm-dialog.component';
import { Observable } from 'rxjs';
import { AlertDialogComponent } from '../components/alert-dialog/alert-dialog.component';
import { ForkDialogComponent } from '../components/fork-dialog/fork-dialog.component';
import { SpinnerDialogComponent } from '../components/spinner-dialog/spinner-dialog.component';
import { IAlertDialogOptions } from '../model/alert-dialog-options.model';
import { IConfirmDialogOptions } from '../model/confirm-dialog-options.model';
import { IForkDialogData } from '../model/fork-dialog.model';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor(private dialog: MatDialog) {}

  openAlertDialog({
    id,
    message,
    dismissText = 'OK',
    image,
    themedImage,
    fullWidth = false,
  }: IAlertDialogOptions): Observable<boolean> {
    const dialogRef = this.dialog.open(AlertDialogComponent, {
      id,
      width: '560px',
      maxWidth: fullWidth ? '100vw' : '80vw',
      autoFocus: false,
      data: {
        image,
        themedImage,
        message,
        dismissText,
      },
    });

    return dialogRef.afterClosed();
  }

  openForkDialog(params: IForkDialogData, fullWidth = false): MatDialogRef<ForkDialogComponent> {
    return this.dialog.open(ForkDialogComponent, {
      disableClose: true,
      data: params,
      width: '560px',
      maxWidth: fullWidth ? '100vw' : '80vw',
    });
  }

  openConfirmDialog({
    id,
    message,
    confirmText,
    cancelText = 'Zrušit',
    image,
    themedImage,
    transparentBackdrop = false,
    fullWidth = false,
  }: IConfirmDialogOptions): Observable<boolean> {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      id,
      width: '560px',
      maxWidth: fullWidth ? '100vw' : '80vw',
      autoFocus: false,
      data: {
        image,
        themedImage,
        message,
        cancelText,
        confirmText,
      },
      backdropClass: transparentBackdrop ? 'cdk-overlay-transparent-backdrop' : null,
    });

    return dialogRef.afterClosed();
  }

  openSpinnerDialog(id: string, text?: string): MatDialogRef<SpinnerDialogComponent> {
    return this.dialog.open(SpinnerDialogComponent, {
      id,
      width: 'auto',
      maxWidth: '80vw',
      autoFocus: false,
      disableClose: true,
      data: {
        text,
      },
    });
  }
}
